
import { Checkbox } from 'element-ui'

export default {
  extends: Checkbox,
}
